import SignUp from '../pages/SignUp.page';

const SignUpRoutes = [
    {
        path: '/sign-up',
        element: <SignUp />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { SignUpRoutes };
